import { CheckSquare, Square } from "lucide-react";
import { formatINR } from "@/lib/quotationApi";

export default function PublicAccessories({ validAccessories, excluded, snapshotMode, toggleItem, primary }) {
  if (validAccessories.length === 0) return null;
  return (
    <div className="card-luxe mb-4">
      <div className="overline text-white/50 mb-3">Accessories</div>
      <div className="space-y-2">
        {validAccessories.map((a) => {
          const isEx = excluded.has(a.id);
          return (
            <div
              key={a.id}
              className="flex justify-between items-center gap-2 text-sm py-1.5 border-b border-white/5 last:border-0"
              data-testid={`public-accessory-row-${a.id}`}
            >
              <div className="flex items-center gap-2 min-w-0">
                {!snapshotMode && (
                  <button
                    type="button"
                    onClick={() => toggleItem(a.id)}
                    className="shrink-0 transition-opacity hover:opacity-80"
                    style={{ color: isEx ? "rgba(255,255,255,0.35)" : primary }}
                    aria-label={isEx ? "Include accessory" : "Exclude accessory"}
                    data-testid={`public-toggle-accessory-${a.id}`}
                  >
                    {isEx ? <Square size={16} /> : <CheckSquare size={16} />}
                  </button>
                )}
                <div className={isEx ? "opacity-50" : ""}>
                  <div className={`font-medium ${isEx ? "pdf-strike" : ""}`}>{a.name}</div>
                  <div className={`text-xs text-white/40 ${isEx ? "pdf-strike" : ""}`}>
                    {formatINR(a.price_per_unit)} × {a.quantity}
                  </div>
                </div>
              </div>
              <div
                className={`font-display font-semibold ${isEx ? "pdf-strike opacity-40 text-white/40" : "text-[#C5A880]"}`}
              >
                {formatINR(a.price_per_unit * a.quantity)}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
